const videoWrapperSelector = '[data-video]';
const videoPlayBtnSelector = '[data-video-btn]';
const videoVolumeBtnSelector = '[data-video-volume]';
const videoElementSelector = '[data-video-media]';
const videoPosterSelector = '[data-video-poster]';

const hidePoster = (props) => {
  props.posterEl.style.display = 'none';

  if (props.posterEl && props.volumeEl) {
    props.volumeEl.style.opacity = 1;
  }
};

const setState = (props) => {
  if (props.posterEl && props.volumeEl) {
    props.volumeEl.style.opacity = 0;
  }

  if (props.mediaEl.muted) {
    props.wrapper.classList.add('is-muted');
  }
};

const introVideo = () => {
  const intro = document.querySelector('.intro');
  const introVideoWrapper = document.querySelector(`.intro ${videoWrapperSelector}`);

  if (!introVideoWrapper || !intro) {
    return;
  }

  const io = new IntersectionObserver(([entity]) => {
    if (!entity.isIntersecting) {
      introVideoWrapper.querySelector(videoElementSelector).muted = true;
      introVideoWrapper.classList.add('is-muted');
    }
  });

  io.observe(intro);
};

const initVideos = () => {
  const videoArr = document.querySelectorAll(videoWrapperSelector);
  introVideo();

  if (videoArr && videoArr.length > 0) {
    videoArr.forEach((videoWrapper) => {
      const propsVideo = {
        wrapper: videoWrapper,
        btnEl: videoWrapper.querySelector(videoPlayBtnSelector),
        volumeEl: videoWrapper.querySelector(videoVolumeBtnSelector),
        mediaEl: videoWrapper.querySelector(videoElementSelector),
        posterEl: videoWrapper.querySelector(videoPosterSelector),
      };
      setState(propsVideo);

      // нужно для работы библиотеки iphone-inline-video (подробнее: liga-reshare/inline-video.html)
      window.enableInlineVideo(propsVideo.mediaEl);

      if (propsVideo.mediaEl && propsVideo.btnEl) {
        videoWrapper.addEventListener('click', (evt) => {
          if (evt.target.closest(videoVolumeBtnSelector)) {
            return;
          }

          if (propsVideo.posterEl) {
            if (propsVideo.posterEl.style.display !== 'none') {
              propsVideo.posterEl.style.opacity = 0;
              setTimeout(() => hidePoster(propsVideo), 800);
            }
          }
          if (propsVideo.mediaEl.paused) {
            propsVideo.mediaEl.play();
            propsVideo.btnEl.style.opacity = 0;
          } else {
            propsVideo.mediaEl.pause();
            propsVideo.btnEl.style.opacity = 1;
          }
        });

        propsVideo.mediaEl.onended = () => {
          propsVideo.btnEl.style.opacity = 1;
        };
      }

      if (propsVideo.mediaEl && propsVideo.volumeEl) {
        propsVideo.volumeEl.addEventListener('click', () => {
          if (videoWrapper.classList.contains('is-muted')) {
            propsVideo.mediaEl.muted = false;
            videoWrapper.classList.remove('is-muted');
          } else {
            propsVideo.mediaEl.muted = true;
            videoWrapper.classList.add('is-muted');
          }
        });
      }
    });
  }
};

export {initVideos};
